import Swiper, { Navigation } from 'swiper';

new Swiper('.swiper-gift-plan-description-container', {
    modules: [Navigation],
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

const modal = document.getElementsByClassName('modal')[0];
const modalTriggerClassName = ['gift-form__label-description', 'gift-container__plans-modal-annotation'];
for (let className of modalTriggerClassName) {
    let triggerDom = document.getElementsByClassName(className)[0];

    if (triggerDom != undefined) {
        console.log(triggerDom);
        triggerDom.addEventListener('click', () => {
            if (!modal.classList.contains('is-active')) {
                modal.classList.add('is-active');
            }
        });
    }
}

document.getElementsByClassName('modal-close')[0].addEventListener('click', () => {
    if (modal.classList.contains('is-active')) {
        modal.classList.remove('is-active');
    }
});

document.getElementsByClassName('modal-background')[0].addEventListener('click', () => {
    if (modal.classList.contains('is-active')) {
        modal.classList.remove('is-active');
    }
});
